import type { RoadmapItemStatus } from "../../types/roadmap";

/** Lifecycle order: filters, status select options, detail modal status pick */
export const ROADMAP_STATUS_ORDER: RoadmapItemStatus[] = [
  "incoming",
  "planned",
  "in_progress",
  "done",
  "wont_do",
];

/**
 * Admin roadmap list sections: newest/active outcomes first, backlog later;
 * won't do last (shown collapsed by default on the page).
 */
export const ROADMAP_SECTION_ORDER: RoadmapItemStatus[] = [
  "done",
  "in_progress",
  "planned",
  "incoming",
  "wont_do",
];

export const ROADMAP_STATUS_LABEL: Record<RoadmapItemStatus, string> = {
  incoming: "Incoming",
  planned: "Planned",
  in_progress: "In progress",
  done: "Done",
  wont_do: "Won't do",
};

/** Ant Design Tag `color` (preset or hex) — one distinct colour per status */
export const ROADMAP_STATUS_TAG_COLOR: Record<RoadmapItemStatus, string> = {
  incoming: "magenta",
  planned: "geekblue",
  in_progress: "gold",
  done: "green",
  wont_do: "purple",
};

export function roadmapStatusLabel(status: RoadmapItemStatus): string {
  return ROADMAP_STATUS_LABEL[status];
}

export function roadmapStatusTagColor(status: RoadmapItemStatus): string {
  return ROADMAP_STATUS_TAG_COLOR[status];
}
